import React, { Component, useRef, useEffect, useState } from "react";
import { Button, Form, Icon, Table, Grid, Card } from "tabler-react";
import {
  Crud_Catalogos,
  Crud_error,
} from "../../../herramientas/Crud_Catalogos";
import ModalLayout from "../../../components/ModalLayout.react";
import ConfigWhatsappTramos from "../../../components/ConfigWhatsappTramos";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import { GoogleMap, useJsApiLoader, Marker, Autocomplete } from "@react-google-maps/api";

const GMAPS_KEY = "AIzaSyDxYRdbyPuyEIOwuVBVwCoaI8ZL6JMPnMQ";
const GMAPS_LIBS = ["places"];

function LocationPicker({ lat, lng, onChange }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GMAPS_KEY,
    libraries: GMAPS_LIBS,
    language: "es",
    region: "MX",
  });

  const [map, setMap] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);

  const hasLocation = lat && lng && !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng));
  const center = hasLocation
    ? { lat: parseFloat(lat), lng: parseFloat(lng) }
    : { lat: 19.4326, lng: -99.1332 };

  const prevCoords = useRef({ lat, lng });
  useEffect(() => {
    if (!map) return;
    if (prevCoords.current.lat === lat && prevCoords.current.lng === lng) return;
    prevCoords.current = { lat, lng };
    if (hasLocation) map.panTo({ lat: parseFloat(lat), lng: parseFloat(lng) });
  }, [lat, lng]); // eslint-disable-line react-hooks/exhaustive-deps

  const onPlaceChanged = () => {
    if (!autocomplete) return;
    const place = autocomplete.getPlace();
    if (place.geometry && place.geometry.location) {
      const newLat = place.geometry.location.lat().toFixed(6);
      const newLng = place.geometry.location.lng().toFixed(6);
      onChange(newLat, newLng);
      if (map) { map.panTo({ lat: parseFloat(newLat), lng: parseFloat(newLng) }); map.setZoom(16); }
    }
  };

  if (!isLoaded) return (
    <div style={{ height: "260px", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8f9fa", borderRadius: "8px", border: "1px solid #dee2e6" }}>
      <span style={{ color: "#9aa0ac", fontSize: "13px" }}>Cargando mapa...</span>
    </div>
  );

  return (
    <div style={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #dee2e6" }}>
      {!hasLocation && (
        <div style={{
          background: "#fff3cd", borderBottom: "1px solid #ffc107",
          padding: "6px 12px", fontSize: "12px", color: "#856404",
          display: "flex", alignItems: "center", gap: "6px",
        }}>
          <Icon name="map-pin" /> Haz clic en el mapa o ingresa las coordenadas para establecer la ubicación
        </div>
      )}
      <GoogleMap
        mapContainerStyle={{ height: "260px", width: "100%" }}
        center={center}
        zoom={hasLocation ? 15 : 5}
        onLoad={setMap}
        onUnmount={() => setMap(null)}
        onClick={(e) => onChange(e.latLng.lat().toFixed(6), e.latLng.lng().toFixed(6))}
        options={{ streetViewControl: false, mapTypeControl: false, fullscreenControl: false }}
      >
        <Autocomplete
          onLoad={setAutocomplete}
          onPlaceChanged={onPlaceChanged}
          options={{ componentRestrictions: { country: "mx" } }}
        >
          <input
            type="text"
            placeholder="Buscar dirección, colonia, ciudad..."
            style={{
              position: "absolute", top: "10px", left: "50%", transform: "translateX(-50%)",
              width: "90%", maxWidth: "440px", padding: "8px 12px",
              border: "none", borderRadius: "6px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
              fontSize: "13px", outline: "none", zIndex: 1,
            }}
          />
        </Autocomplete>
        {hasLocation && (
          <Marker
            position={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
            draggable={true}
            onDragEnd={(e) => onChange(e.latLng.lat().toFixed(6), e.latLng.lng().toFixed(6))}
          />
        )}
      </GoogleMap>
    </div>
  );
}

var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
class Cliente extends Component {
  constructor(props) {
    console.log(props)
    super(props);
    this.state = {
      //Campos de la Entity
      id: "",
      nombre: "",
      nombreCorto: "",
      domicilio: "",
      contacto: "",
      telefono: "",
      extension: "",
      nota: "",
      vip: 0,
      latitud: 0,
      longitud: 0,
      estatus: 1,
      notificacionesWhatsApp:0,
      idPlataformaTipo: { value: 0, label: "Selecciona tipo de plataforma" },
      idMovimientoTipo: { value: 0, label: "Selecione tipo de movmiento" },
      idCampoLogistico: { value: 0, label: " Seleccione un campoLogistico" },
      idTarifarioSubasta: { value: 0, label: "Selecciona una localidad"},
      idVertical: { value:0 , label: "Selecciona una localidad"} ,
      camposLogisticos: [],
      movimientosTipo: [],
      tarifarioSubasta: [],
      clientesVerticales:[],
      idGeocerca: "",
      verBitacora: false,
      cron: "00:00:00",
      wt: "00:00:00",
      cuentas: [],
      cuenta: { value: null, label: "Seleccione una cuenta" },
      crudbutonEnable: true, // Se desabilita cuando se hace click
      hiddenModals: false,
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      configuracionesClienteConsolidado: [],
    };
    this.idPlataformaTipos = [
      { value: 0, label: "Selecciona tipo de plataforma" },
      { value: 1, label: "Naviera" },
      { value: 2, label: "Terrestre" },
    ];
    this.plataformaId = 0;
    this.clienteObject = {
      id: 0,
      nombre: "",
      nombreCorto: "",
      domicilio: "",
      contacto: "",
      telefono: "",
      extension: "",
      nota: "",
      vip: "",
      notificacionesWhatsApp:"",
      latitud: "",
      ongitud: "",
      estatus: 1,
      idPlataformaTipo: 0,
      idCampoLogistico: null,
      idGeocerca: "",
      verBitacora: false,
      cron: "00:00:00",
      wt: "12:00:00",
      idCuenta: null,
      idClienteVertical:null,
      idTarifarioSubasta: null,
    };
    this.configuracionClienteConsolidado = {
      idCliente: this.props.elementos ? this.props.elementos.id : null,
      idMovimientoTipo: 0,
      idCampoLogistico: 0,
    };
    this.configuracion = {};
    this.tarifarioSubasta = [];
  }
  isEnable = (Accion) => {
    let borrar = "clientes_borrar";
    let actualizar = "clientes_editar";
    let agregar = "clientes_agregar";
    var privilegios = this.props.stor.privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (Accion === "borrar") {
        if (privilegios[i].clave == borrar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "actualizar") {
        if (privilegios[i].clave == actualizar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregar") {
        if (privilegios[i].clave == agregar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio == privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  componentDidMount = () => {
    if (this.state.accion !== "nuevo") {
      this.clienteObject = this.props.elementos;
      this.setState({
        id: this.props.elementos.id ? this.props.elementos.id : "",
      });
      this.setState({
        nombre: this.props.elementos.nombre ? this.props.elementos.nombre : "",
      });
      this.setState({
        nombreCorto: this.props.elementos.nombreCorto
          ? this.props.elementos.nombreCorto
          : "",
      });
      this.setState({
        domicilio: this.props.elementos.domicilio
          ? this.props.elementos.domicilio
          : "",
      });
      this.setState({
        contacto: this.props.elementos.contacto
          ? this.props.elementos.contacto
          : "",
      });
      this.setState({
        telefono: this.props.elementos.telefono
          ? this.props.elementos.telefono
          : "",
      });
      this.setState({
        extension: this.props.elementos.extension
          ? this.props.elementos.extension
          : "",
      });
      this.setState({
        nota: this.props.elementos.nota ? this.props.elementos.nota : "",
      });
      this.setState({
        vip: this.props.elementos.vip ? this.props.elementos.vip : "",
      });

       this.setState({
        notificacionesWhatsApp: this.props.elementos?.notificacionesWhatsApp ? this.props.elementos.notificacionesWhatsApp : "",
      });

      this.setState({
        latitud: this.props.elementos.latitud
          ? this.props.elementos.latitud
          : "",
      });
      this.setState({
        longitud: this.props.elementos.longitud
          ? this.props.elementos.longitud
          : "",
      });
      this.setState({
        estatus: this.props.elementos.estatus
          ? this.props.elementos.estatus
          : "",
      });
      this.setState({
        idGeocerca: this.props.elementos.idGeocerca
          ? this.props.elementos.idGeocerca
          : "",
      });
      this.setState({
        verBitacora: this.props.elementos.verBitacora ? this.props.elementos.verBitacora : false,
      });
      this.setState({
        cron: this.props.elementos.cron
          ? this.props.elementos.cron
          : "00:00:00",
      });
      this.setState({
        wt: this.props.elementos.wt ? this.props.elementos.wt : "12:00:00",
      });
      this.setState({
        idTarifarioSubasta: this.props.elementos.idTarifarioSubasta
          ? {
              value: this.props.elementos.idTarifarioSubasta.id,
              label: this.props.elementos.idTarifarioSubasta.localidad,
            }
          : { value: 0, label: "Selecciona una localidad" },
      });
      for (let item of this.idPlataformaTipos) {
        if (item.value === this.props.elementos.idPlataformaTipo) {
          this.setState({ idPlataformaTipo: item });
          this.clienteObject.idPlataformaTipo = item.value;
        }
      }
      this.getfuntion("get", "", "", "camposLogisticos", "camposLogisticos");
      this.getfuntion("get", "", "", "movimientosTipo", "movimientosTipo");
    } else {
      if (this.props.plataforma) {
        if (this.props.plataforma.plataformaTipo) {
          if (
            this.props.plataforma.plataformaTipo.id === 1 ||
            this.props.plataforma.plataformaTipo.id === 2
          ) {
            this.setState({
              idPlataformaTipo: {
                value: this.props.plataforma.plataformaTipo.id,
                label: this.props.plataforma.plataformaTipo.nombre,
              },
            });
            this.clienteObject.idPlataformaTipo =
              this.props.plataforma.plataformaTipo.id;
          }
          if (this.props.plataforma.plataformaTipo.id === 3) {
            this.setState({ idPlataformaTipo: { value: 1, label: "Naviera" } });
            this.clienteObject.idPlataformaTipo = 1;
          }
        }
      }
      //this.clienteObject = {"id":0, "nombre":"", "nombreCorto":"", "domicilio":"", "contacto":"", "telefono":"", "extension":"", "nota":"", "vip":"", "latitud":"", "ongitud":"", "estatus":""};
    }
    if(this.props.plataforma){
      this.getfuntion( "get", "", "", "cuentas/plataforma/" + this.props.plataforma.id, "cuentas" );     
    }
    if(this.props.plataforma && this.props.plataforma.id === 886){
      this.getfuntion( "get", "", "", "tarifarioSubasta", "tarifarioSubasta" );
    }

    if(this.props.plataforma && this.props.plataforma.id === 1){
      this.getfuntion( "get", "", "", "clientes_verticales", "clientes_verticales" );
    }
   
  };
  hiddenmodal = () => {
    this.setState({ hiddenModals: false });
  };
  getfuntion = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "personas",
    stateVar = "personas",
    hiddenModl = ""
  ) => {
    Crud_Catalogos(
      catalogo,
      "plataformas",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    )
      .then((returnVal) => {
        /**
         * filtro de variables
         */
        switch (metodo) {
          case "get":
            {
              if (stateVar === "camposLogisticos" && returnVal) {
                let calogs = [
                  { value: null, label: "Seleccione un campoLogistico" },
                ];
                for (let item of returnVal) {
                  calogs.push({
                    value: item.id,
                    label: item.nombre,
                    data: item,
                  });
                }
                this.camposLogisticos = calogs;
                this.setState({
                  idCampoLogistico: {
                    value: 0,
                    label: "Seleccione un tipo de movimiento",
                  },
                });
              }

              if (stateVar === "movimientosTipo") {
                this.movimientoTipos = [];
                returnVal.map((mt, index) =>
                  this.movimientoTipos.push({
                    value: mt.id,
                    label: mt.nombre,
                    data: mt,
                  })
                );
                this.setState({ movimientosTipo: this.movimientoTipos });
                if (this.props.accion == "nuevo") {
                  this.setState({
                    idMovimientoTipo: {
                      value: 0,
                      label: "Selecciona un Tipo de movimiento",
                    },
                  });
                }
                this.getfuntion(
                  "get",
                  "",
                  "",
                  "configuracionClienteConsolidado/cliente/" +
                    this.props.elementos.id,
                  "configuracion"
                );
              }
              if (stateVar === "configuracion") {
                this.setState({ configuracionesClienteConsolidado: returnVal });
              }
              if (stateVar === "cuentas" && returnVal) {
                let cunetasTemp = [{ value: null, label: "Seleccione una cuenta" },];
                for (let item of returnVal) {
                  cunetasTemp.push({ value: item.id, label: item.nombre, data: item, });                  
                  if( this.clienteObject.idCuenta === item.id ){
                    console.log(this.clienteObject);
                    console.log(item);
                    console.log(cunetasTemp[cunetasTemp.length-1]);
                    this.clienteObject.idCuenta= item.id;
                    this.setState({ cuenta: cunetasTemp[cunetasTemp.length-1] });
                  }
                }
                this.setState({ cuentas: cunetasTemp });
              }

              if(stateVar === "clientes_verticales" ){
                this.clientesVerticales = [];
                returnVal.map((cv, index) => {
                  if(this.props.elementos.idClienteVertical == cv.id){
                    console.log("pasososo")
                    this.setState({idVertical: { value: cv.id ,label:cv.nombre}})
                  }
                  this.clientesVerticales.push({
                    value: cv.id,
                    label: cv.nombre,
                    data: cv,
                  });
                });
                this.setState({ clientesVerticales: this.clientesVerticales });
              }
              if (stateVar === "tarifarioSubasta") {
                this.tarifarioSubasta = [];
                returnVal.map((ts, index) => {
                  this.tarifarioSubasta.push({
                    value: ts.id,
                    label: ts.localidad,
                    data: ts,
                  });
                });
                this.setState({ tarifarioSubasta: this.tarifarioSubasta });
                if (this.props.accion == "nuevo") {
                  this.setState({
                    idTarifarioSubasta: {
                      value: 0,
                      label: "Selecciona un Ejecutivo",
                    },
                  });
                }
              }
            }
            break;
          case "post":
            {
              if (stateVar === "configuracion") {
                NotificationManager.info("Guardado ..", "Guardado");
                let confTemp = this.state.configuracionesClienteConsolidado;
                confTemp.push(returnVal);
                this.setState({ configuracionesClienteConsolidado: confTemp });
              }
            }
            break;
          case "delete":
            {
              if (stateVar === "configuracion") {
                let confTemp = this.state.configuracionesClienteConsolidado;
                confTemp.map((item, index) => {
                  if (
                    item.idCliente +
                      "/" +
                      item.idMovimientoTipo +
                      "/" +
                      item.idCampoLogistico ===
                    id
                  ) {
                    if (returnVal) {
                      confTemp.splice(index, 1);
                      NotificationManager.info("Borrado ..", "Guardado");
                    } else {
                      NotificationManager.info(
                        "No se ha podido borrar ..",
                        "Error"
                      );
                    }
                    this.setState({
                      configuracionesClienteConsolidado: confTemp,
                    });
                  }
                });
              }
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  enableSave = () => {
    if (
      this.state.nombre.length > 0 &&
      this.state.nombreCorto.length > 0 &&
      this.state.domicilio.length > 0 &&
      this.state.idPlataformaTipo.value > 0
    ) {
      return false;
    } else {
      return true;
    }
  };
  guardarCliente = () => {
    if (this.state.accion === "modificar") this.crud_put();
    else this.crud_post();
    this.props.cerrarModal();
  };
  delete() {
    this.props.getfuntion("delete", "", this.state.id);
    this.setState({ crudbutonEnable: false });
  }
  crud_put() {
    this.props.getfuntion("put", this.clienteObject);
    this.setState({ crudbutonEnable: false });
  }
  crud_post() {
    this.props.getfuntion("post", this.clienteObject);
    this.setState({ crudbutonEnable: false });
  }
  changeNombre = (event) => {
    this.clienteObject.nombre = event.target.value;
    this.setState({ nombre: event.target.value });
  };
  changeNombreCorto = (event) => {
    this.clienteObject.nombreCorto = event.target.value;
    this.setState({ nombreCorto: event.target.value });
  };
  changeDomicilio = (event) => {
    this.clienteObject.domicilio = event.target.value;
    this.setState({ domicilio: event.target.value });
  };
  changeContacto = (event) => {
    this.clienteObject.contacto = event.target.value;
    this.setState({ contacto: event.target.value });
  };
  changeTelefono = (event) => {
    this.clienteObject.telefono = event.target.value;
    this.setState({ telefono: event.target.value });
  };
  changeExtension = (event) => {
    this.clienteObject.extension = event.target.value;
    this.setState({ extension: event.target.value });
  };
  changeLatitud = (event) => {
    this.clienteObject.latitud = event.target.value;
    this.setState({ latitud: event.target.value });
  };
  changeLongitud = (event) => {
    this.clienteObject.longitud = event.target.value;
    this.setState({ longitud: event.target.value });
  };
  setUbicacionDesdeMap = (lat, lng) => {
    this.clienteObject.latitud = lat;
    this.clienteObject.longitud = lng;
    this.setState({ latitud: lat, longitud: lng });
  };
  changeNota = (event) => {
    this.clienteObject.nota = event.target.value;
    this.setState({ nota: event.target.value });
  };
  changeIdGeocerca = (event) => {
    this.clienteObject.idGeocerca = event.target.value;
    this.setState({ idGeocerca: event.target.value });
  };
  changeVip = (event) => {
    this.clienteObject.vip = event.target.checked ? 1 : 0;
    this.setState({ vip: event.target.checked ? 1 : 0 });
  };

   changeNotificacionesWhatsApp = (event) => {
    this.clienteObject.notificacionesWhatsApp = event.target.checked ? 1 : 0;
    this.setState({ notificacionesWhatsApp: event.target.checked ? 1 : 0 });
  };

    changeVerBitacora = (event) => {
    this.clienteObject.verBitacora = event.target.checked ? true : false;
    this.setState({ verBitacora: event.target.checked ? true : false });
  };
  changeEstatus = (event) => {
    this.state.estatus === 0
      ? this.setState({ estatus: 1 })
      : this.setState({ estatus: 0 });
    this.state.estatus === 0
      ? (this.clienteObject.estatus = 1)
      : (this.clienteObject.estatus = 0);
  };

  changeCron = (e) => {
    this.clienteObject.cron = e.target.value;
    this.setState({ cron: e.target.value });
  };
  changeWt = (e) => {
    this.clienteObject.wt = e.target.value;
    this.setState({ wt: e.target.value });
  };

  changePlataformaTipo = (e) => {
    this.clienteObject.idPlataformaTipo = e.value;
    this.setState({ idPlataformaTipo: e });
  };
  changeMovimientoTipo = (event) => {
    this.setState({ idMovimientoTipo: event });
    this.configuracionClienteConsolidado.idMovimientoTipo = event.value;
    let idMotipoCampoLog = 0;
    if (event.value === 1 || event.value === 3) {
      idMotipoCampoLog = 1;
    }
    if (event.value === 2 || event.value === 4) {
      idMotipoCampoLog = 2;
    }
    let camposMapeados =
      "arribo_cliente_lleno, arribo_cliente_vacio, fecha_arribo, salida_cliente_vacio, salida_cliente_lleno, fecha_salida, arribo_patio_linea, arribo_terminal_vacio_2, arribo_terminal_cargado";
    let calogs = [{ value: 0, label: "Seleccione un campoLogistico" }];
    for (let item of this.camposLogisticos) {
      if (item.data) {
        if (
          item.data.idMovimientoTipo === idMotipoCampoLog &&
          camposMapeados.includes(item.data.nombreCampo)
        ) {
          console.log(item.data);
          calogs.push(item);
        }
      }
    }
    this.setState({ camposLogisticos: calogs });
  };
  changeCampoLogistico = (e) => {
    this.setState({ idCampoLogistico: e });
    this.configuracionClienteConsolidado.idCampoLogistico = e.value;
  };
  changeTarifarioSubasta = (event) => {
    this.clienteObject.idTarifarioSubasta = event.data;
    this.setState({ idTarifarioSubasta: event });
  } 

  changeVertical = (event) => {

    console.log(event)
    this.clienteObject.idVertical = event.value;
    this.setState({ idVertical: event });
  } 

  getMovimientoTipoLabel = (id) => {
    for (let item of this.state.movimientosTipo) {
      if (item.value === id) {
        return item.label;
      }
    }
    return "";
  };
  getCampoLogisticoLabel = (id) => {
    for (let item of this.camposLogisticos) {
      if (item.value === id) {
        return item.label;
      }
    }
    return "";
  };
  validar = () => {
    let invalido = false;
    this.state.configuracionesClienteConsolidado.map((conf, index) => {
      if (
        this.state.idMovimientoTipo.value === conf.idMovimientoTipo || //this.state.idCampoLogistico.value === conf.idCampoLogistico ||
        this.state.idMovimientoTipo.value === 0 ||
        this.state.idCampoLogistico.value === 0
      ) {
        invalido = true;
      }
    });
    return invalido;
  };
  saveConfiguracionPlantillaConsolidado = () => {
    this.getfuntion(
      "post",
      this.configuracionClienteConsolidado,
      "",
      "configuracionClienteConsolidado",
      "configuracion"
    );
  };
  borrarConfiguracionClienteConsolidado = (idCliente, idmTipo, idCamLog) => {
    this.getfuntion(
      "delete",
      "",
      idCliente + "/" + idmTipo + "/" + idCamLog,
      "configuracionClienteConsolidado",
      "configuracion"
    );
  };

  render() {
    const sectionHeader = {
      fontSize: "11px",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.08em",
      color: "#6c757d",
      borderBottom: "2px solid #e9ecef",
      paddingBottom: "6px",
      marginBottom: "16px",
      marginTop: "8px",
    };
    const switchCard = (title, subtitle, switchEl) => (
      <div style={{
        background: "#f8f9fa", borderRadius: "8px", padding: "12px 16px",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        border: "1px solid #e9ecef", height: "100%",
      }}>
        <div>
          <div style={{ fontWeight: 600, fontSize: "13px", color: "#354052" }}>{title}</div>
          <div style={{ fontSize: "11px", color: "#9aa0ac" }}>{subtitle}</div>
        </div>
        {switchEl}
      </div>
    );
    const configModalContent = (
      <div>
        <Grid.Row>
          <Grid.Col sm={5} md={5}>
            <Form.Group label="Tipo de movimiento">
              <Select
                value={this.state.idMovimientoTipo}
                onChange={this.changeMovimientoTipo}
                options={this.state.movimientosTipo}
              />
            </Form.Group>
          </Grid.Col>
          <Grid.Col sm={5} md={5}>
            <Form.Group label="Campo logístico">
              <Select
                value={this.state.idCampoLogistico}
                onChange={this.changeCampoLogistico}
                options={this.state.camposLogisticos}
                isLoading={this.state.camposLogisticos.length === 0}
              />
            </Form.Group>
          </Grid.Col>
          <Grid.Col sm={2} md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "4px" }}>
            <Button
              pill
              size="sm"
              color="primary"
              onClick={() => this.saveConfiguracionPlantillaConsolidado()}
              disabled={this.validar()}
            >
              <Icon name="save" />
              {" "}Guardar
            </Button>
          </Grid.Col>
        </Grid.Row>
        <Table
          cards={true}
          striped={true}
          responsive={true}
          className="table-vcenter table-sm"
          headerItems={[
            { content: "Tipo movimiento" },
            { content: "Campo logístico" },
            { content: "Acción" },
          ]}
        >
          <Table.Header />
          <Table.Body>
            {this.state.configuracionesClienteConsolidado.map((conf, index) => (
              <Table.Row key={index}>
                <Table.Col>{this.getMovimientoTipoLabel(conf.idMovimientoTipo)}</Table.Col>
                <Table.Col>{this.getCampoLogisticoLabel(conf.idCampoLogistico)}</Table.Col>
                <Table.Col>
                  <Button
                    size="sm"
                    color="danger"
                    outline
                    onClick={() =>
                      this.borrarConfiguracionClienteConsolidado(
                        conf.idCliente,
                        conf.idMovimientoTipo,
                        conf.idCampoLogistico
                      )
                    }
                  >
                    <Icon name="trash" />
                  </Button>
                </Table.Col>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    );

    return (
      <div style={{ padding: "4px 0" }}>

        {/* Header con nombre del cliente en modo edición */}
        {this.state.accion === "modificar" && (
          <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", gap: "12px" }}>
            <div style={{
              width: "44px", height: "44px", borderRadius: "50%",
              background: "linear-gradient(135deg, #467fcf 0%, #3a6abf 100%)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontWeight: 700, fontSize: "17px", flexShrink: 0,
            }}>
              {this.props.elementos.nombre ? this.props.elementos.nombre.charAt(0).toUpperCase() : "C"}
            </div>
            <div>
              <h3 style={{ margin: 0, fontWeight: 700, color: "#354052", lineHeight: 1.2 }}>
                {this.props.elementos.nombre}
              </h3>
              <small style={{ color: "#9aa0ac" }}>ID #{this.state.id}</small>
            </div>
            <span style={{ marginLeft: "auto" }}>
              <span
                className={`badge badge-${this.state.estatus ? "success" : "secondary"}`}
                style={{ fontSize: "12px", padding: "4px 12px" }}
              >
                {this.state.estatus ? "Activo" : "Inactivo"}
              </span>
            </span>
          </div>
        )}

        {/* ── SECCIÓN 1: Información General ── */}
        <Card>
          <Card.Body>
            <p style={sectionHeader}><Icon name="briefcase" className="mr-1" /> Información General</p>
            <Grid.Row>
              {this.state.accion !== "nuevo" && (
                <Grid.Col md={2}>
                  <Form.Group label="ID">
                    <Form.Input name="id" disabled type="number" value={this.state.id} />
                  </Form.Group>
                </Grid.Col>
              )}
              <Grid.Col md={this.state.accion !== "nuevo" ? 4 : 5}>
                <Form.Group label="Nombre *">
                  <Form.Input
                    name="nombre" type="text" value={this.state.nombre}
                    onChange={this.changeNombre} maxLength="100"
                    placeholder="Nombre completo del cliente"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={3}>
                <Form.Group label="Nombre corto *">
                  <Form.Input
                    name="nombreCorto" type="text" value={this.state.nombreCorto}
                    onChange={this.changeNombreCorto} maxLength="100"
                    placeholder="Alias / abreviatura"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={3}>
                <Form.Group label="Nota">
                  <Form.Input
                    name="nota" type="text" value={this.state.nota}
                    onChange={this.changeNota} maxLength="255"
                    placeholder="Observaciones"
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>
            <Grid.Row>
              <Grid.Col md={5}>
                <Form.Group label="Domicilio *">
                  <Form.Input
                    name="domicilio" type="text" value={this.state.domicilio}
                    onChange={this.changeDomicilio} maxLength="300"
                    placeholder="Dirección del cliente"
                  />
                </Form.Group>
              </Grid.Col>
              {!this.props.usuarioCliente && (
                <Grid.Col md={3}>
                  <Form.Group label="Tipo de plataforma *">
                    <Select
                      value={this.state.idPlataformaTipo}
                      onChange={this.changePlataformaTipo}
                      options={this.idPlataformaTipos}
                    />
                  </Form.Group>
                </Grid.Col>
              )}
              {this.props.plataforma && (
                <Grid.Col md={2}>
                  <Form.Group label="Cuenta">
                    <Select
                      value={this.state.cuenta}
                      onChange={(e) => {
                        this.setState({ idCuenta: e });
                        this.clienteObject.idCuenta = e.value;
                      }}
                      options={this.state.cuentas}
                    />
                  </Form.Group>
                </Grid.Col>
              )}
              {[886].includes(this.props.plataforma?.id) && (
                <Grid.Col md={2}>
                  <Form.Group label="Localidad Subasta">
                    <Select
                      value={this.state.idTarifarioSubasta}
                      onChange={this.changeTarifarioSubasta}
                      options={this.state.tarifarioSubasta}
                      isLoading={this.state.tarifarioSubasta.length === 0}
                    />
                  </Form.Group>
                </Grid.Col>
              )}
              {[1].includes(this.props.plataforma?.id) && (
                <Grid.Col md={2}>
                  <Form.Group label="Vertical">
                    <Select
                      value={this.state.idVertical}
                      onChange={(e) => {
                        this.setState({ idVertical: e });
                        this.clienteObject.idClienteVertical = e.value;
                      }}
                      options={this.state.clientesVerticales}
                      isLoading={this.state.clientesVerticales.length === 0}
                    />
                  </Form.Group>
                </Grid.Col>
              )}
            </Grid.Row>
          </Card.Body>
        </Card>

        {/* ── SECCIÓN 2: Contacto ── */}
        <Card style={{ marginTop: "12px" }}>
          <Card.Body>
            <p style={sectionHeader}><Icon name="phone" className="mr-1" /> Contacto</p>
            <Grid.Row>
              <Grid.Col md={5}>
                <Form.Group label="Nombre de contacto">
                  <Form.Input
                    name="contacto" type="text" value={this.state.contacto}
                    onChange={this.changeContacto} maxLength="50"
                    placeholder="Persona de contacto"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={4}>
                <Form.Group label="Teléfono">
                  <Form.Input
                    name="telefono" type="text" value={this.state.telefono}
                    onChange={this.changeTelefono} maxLength="20"
                    placeholder="Número de teléfono"
                  />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={3}>
                <Form.Group label="Extensión">
                  <Form.Input
                    name="extension" type="text" value={this.state.extension}
                    onChange={this.changeExtension} maxLength="10"
                    placeholder="Ext."
                  />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>
          </Card.Body>
        </Card>

        {/* ── SECCIÓN 3: Ubicación ── */}
        <Card style={{ marginTop: "12px" }}>
          <Card.Body>
            <p style={sectionHeader}><Icon name="map-pin" className="mr-1" /> Ubicación</p>
            <Grid.Row>
              <Grid.Col md={4}>
                <Grid.Row>
                  <Grid.Col md={12}>
                    <Form.Group label="Latitud">
                      <Form.Input
                        name="latitud" type="text" value={this.state.latitud}
                        onChange={this.changeLatitud} maxLength="20"
                        placeholder="Ej. 19.432608"
                      />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={12}>
                    <Form.Group label="Longitud">
                      <Form.Input
                        name="longitud" type="text" value={this.state.longitud}
                        onChange={this.changeLongitud} maxLength="20"
                        placeholder="Ej. -99.133209"
                      />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={12}>
                    <Form.Group label="ID Geocerca (GPSGate)">
                      <Form.Input
                        name="idgeocerca" type="text" value={this.state.idGeocerca}
                        onChange={this.changeIdGeocerca} maxLength="40"
                        placeholder="ID-000-KKK"
                      />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col md={12}>
                    <div style={{
                      background: "#e8f4fd", borderRadius: "6px", padding: "8px 12px",
                      fontSize: "11px", color: "#2c7be5", border: "1px solid #bee3f8",
                    }}>
                      <Icon name="info" /> Haz clic en el mapa o arrastra el marcador para actualizar las coordenadas
                    </div>
                  </Grid.Col>
                </Grid.Row>
              </Grid.Col>
              <Grid.Col md={8}>
                <LocationPicker
                  lat={this.state.latitud}
                  lng={this.state.longitud}
                  onChange={this.setUbicacionDesdeMap}
                />
              </Grid.Col>
            </Grid.Row>
          </Card.Body>
        </Card>

        {/* ── SECCIÓN 4: Configuración y permisos ── */}
        {!this.props.usuarioCliente && (
          <Card style={{ marginTop: "12px" }}>
            <Card.Body>
              <p style={sectionHeader}><Icon name="settings" className="mr-1" /> Configuración y Permisos</p>
              <Grid.Row>
                <Grid.Col md={3}>
                  {switchCard("VIP", "Cliente prioritario",
                    <Form.Switch type="Checkbox" name="vip" checked={this.state.vip} onChange={this.changeVip} />
                  )}
                </Grid.Col>
                {/* <Grid.Col md={3}>
                  {switchCard("WhatsApp", "Envío automatizado",
                    <Form.Switch type="Checkbox" name="automatizadoWhatsApp" checked={this.state.notificacionesWhatsApp} onChange={this.changeNotificacionesWhatsApp} />
                  )}
                </Grid.Col> */}
                <Grid.Col md={3}>
                  {switchCard("Ver Bitácora", "Acceso al historial",
                    <Form.Switch type="Checkbox" name="verBitacora" checked={this.state.verBitacora} onChange={this.changeVerBitacora} />
                  )}
                </Grid.Col>
                <Grid.Col md={3}>
                  {switchCard("Estatus", "Activo / Inactivo",
                    <Form.Switch type="Checkbox" name="toggle" value={this.state.estatus} checked={this.state.estatus} onChange={this.changeEstatus} />
                  )}
                </Grid.Col>
              </Grid.Row>

              {this.props.elementos && (
                <>
                  <p style={{ ...sectionHeader, marginTop: "20px" }}>
                    <Icon name="clock" className="mr-1" /> Configuración de Consolidados
                  </p>
                  <Grid.Row>
                    <Grid.Col md={3}>
                      <Form.Group label="Tiempo de envío consolidado">
                        <Form.MaskedInput
                          placeholder="HH:MM:SS" value={this.state.cron}
                          onChange={this.changeCron}
                          mask={[/\d/, /\d/, ":", /\d/, /\d/, ":", /\d/, /\d/]}
                        />
                      </Form.Group>
                    </Grid.Col>
                    <Grid.Col md={3}>
                      <Form.Group label="Waiting time">
                        <Form.MaskedInput
                          placeholder="HH:MM:SS" value={this.state.wt}
                          onChange={this.changeWt}
                          mask={[/\d/, /\d/, ":", /\d/, /\d/, ":", /\d/, /\d/]}
                        />
                      </Form.Group>
                    </Grid.Col>
                    <Grid.Col md={3}>
                      <Form.Group label="Configuración envío WhatsApp">
                        <ModalLayout
                          tamanio={"70%"}
                          title="Configuración de tramos WhatsApp"
                          name={
                            <Button pill size="sm" outline color="primary" block>
                              <Icon name="message-square" /> Configurar tramos
                            </Button>
                          }
                          hiddenModal={this.state.hiddenModals}
                          Fclose={this.hiddenmodal}
                          formulario={
                            <ConfigWhatsappTramos
                              idCliente={this.props.elementos.id}
                              idPlataforma={this.props.plataforma?.id}
                            />
                          }
                        />
                      </Form.Group>
                    </Grid.Col>
                    <Grid.Col md={3}>
                      <Form.Group label="Detener envío de consolidado">
                        <ModalLayout
                          tamanio={"60%"}
                          title="Detener envío de consolidado"
                          name={
                            <Button pill size="sm" outline color="warning" block>
                              <Icon name="pause" /> Configurar parada
                            </Button>
                          }
                          hiddenModal={this.state.hiddenModals}
                          Fclose={this.hiddenmodal}
                          formulario={configModalContent}
                        />
                      </Form.Group>
                    </Grid.Col>
                  </Grid.Row>
                </>
              )}
            </Card.Body>
          </Card>
        )}

        {/* Barra de acciones */}
        <div style={{
          display: "flex", justifyContent: "flex-end", gap: "8px",
          marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #e9ecef",
        }}>
          {this.state.accion === "modificar" && this.isEnable("borrar") && (
            <Button size="sm" color="danger" outline
              onClick={() => this.delete()} disabled={!this.state.crudbutonEnable}
            >
              <Icon name="trash" /> Eliminar
            </Button>
          )}
          {this.isEnable("actualizar" || this.isEnable("agregar")) && (
            <Button size="sm" color="primary"
              disabled={this.enableSave() || !this.state.crudbutonEnable}
              onClick={this.guardarCliente}
            >
              <Icon name="save" /> Guardar cambios
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default Cliente;
